//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { MEDIA_TRACKING_LOG_MSG_PREFIX } from '@tracker/mediaTracking/constants/mediaTrackingConstants';

export interface IMediaTrackingLogger {
  debug: (...args: any[]) => void;
  log: (...args: any[]) => void;
}

export const getMediaTrackingLogger = (
  isDebugEnabled: boolean,
): IMediaTrackingLogger => {
  const logMsg = (...args: any[]): void => {
    if (!isDebugEnabled) {
      return;
    }
    console.log(...args);
  };

  const logMsgWithPrefix = (...args: any[]): void => {
    logMsg(MEDIA_TRACKING_LOG_MSG_PREFIX, ...args);
  };

  return {
    debug: logMsgWithPrefix,
    log: logMsg,
  };
};
